import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const p = window.location.pathname || "";
      // Public route'larda 401 gelince login'e yönlendirme (TV signage / help)
      const isPublic = p.startsWith("/screen/") || p.startsWith("/s/") || p.startsWith("/menu/") || p === "/help" || p === "/login";
      if (!isPublic) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatErr(detail) {
  if (detail == null) return "Bir hata oluştu";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}

export const fmtTL = (n) =>
  new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", maximumFractionDigits: 2 }).format(Number(n || 0));

export const fmtN = (n) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 }).format(Number(n || 0));

// İş günü tarihi: gece 05:00'ten önce = önceki gün.
// Geç kapatan şubeler saat 03:30'da raporu doldursa bile bir önceki iş gününe kaydeder.
// businessDate(): YYYY-MM-DD (yerel tarih)
export const businessDate = (d = new Date()) => {
  const shifted = new Date(d.getTime() - 5 * 60 * 60 * 1000);
  const y = shifted.getFullYear();
  const m = String(shifted.getMonth() + 1).padStart(2, "0");
  const dd = String(shifted.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
};

// Fetch wrapper for binary downloads (uses axios cookies + Bearer if any)
export async function downloadFile(path, filename) {
  // Cache-buster: her indirmede benzersiz URL üret ki tarayıcı/Cloudflare eski dosyayı cache'den döndürmesin
  const sep = path.includes("?") ? "&" : "?";
  const bustedPath = `${path}${sep}_ts=${Date.now()}`;
  const res = await api.get(bustedPath, { responseType: "blob" });
  // Some servers return JSON error inside blob when 4xx — try to parse
  const ct = (res.headers?.["content-type"] || "").toLowerCase();
  if (ct.startsWith("application/json")) {
    const text = await res.data.text();
    let msg = "Dosya oluşturulamadı";
    try { msg = JSON.parse(text)?.detail || msg; } catch (_) { /* ignore */ }
    throw new Error(msg);
  }
  const blob = res.data instanceof Blob ? res.data : new Blob([res.data]);
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export default api;
